<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="证书类型" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.authcn_project_class || scope.row.authcn_project_division || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="认证依据">
            <template slot-scope="scope">
              {{ scope.row.authcn_basis || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="证书编号">
            <template slot-scope="scope">
              {{ scope.row.certificate_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="发证机构">
            <template slot-scope="scope">
              {{ scope.row.issue_institution_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="证书状态">
            <template slot-scope="scope">
              {{ scope.row.certificate_status || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="发证日期">
            <template slot-scope="scope">
              {{ scope.row.issue_certificate_date || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="截止日期">
            <template slot-scope="scope">
              {{ scope.row.certificate_mature_date || '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'certificationList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '资质证书',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>